import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import globals from '../../../globals/communityGlobals';
import { overrideBundleDuration } from '../../../actions/areas/planner';

const locale = globals.getArea('treatments');
export default function EditActivitiesDuration({
  openDurationPanel,
  onEditDuration,
  getAccessToken,
  treatmentInstanceId,
  toggleRefresh,
  refreshClinicianTreatmentsAndClosePanels,
}) {
  const [duration, setDuration] = useState(null);

  const canSave = () => {
    if (duration == null) return false;

    return duration.selectedTotalTime > 0 && duration.selectedTotalTime <= 1440;
  };

  const validateFormData = () => {
    let errorMsg = '';
    if (duration == null) return errorMsg;

    if ((duration.selectedTotalTime !== '' && duration.selectedTotalTime <= 0) || duration.selectedTotalTime > 1440) {
      errorMsg = locale.getMsg('totalDurationErrorMsg');
    }
    return errorMsg;
  };

  const errorPlaceholder = () => {
    const errorMsg = validateFormData();
    if (errorMsg === '') return null;

    return (
      <span className="form-validation-error">
        <p>{errorMsg}</p>
      </span>
    );
  };

  const save = () => {
    onEditDuration(duration.selectedTotalTime);
    openDurationPanel(false);
  };

  const saveBundledDuration = () => {
    onEditDuration(duration.selectedTotalTime);

    const model = { treatmentInstanceId, overriddenBundleDuration: duration.selectedTotalTime };
    overrideBundleDuration(getAccessToken, model);
    openDurationPanel(false);
    toggleRefresh();
    refreshClinicianTreatmentsAndClosePanels();
  };

  const headerRender = () => {
    return (
      <div className="sidePanel-header form-header">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">{locale.getMsg('editDuration')}</Typography>
            </Box>
            <Box>
              <IconButton onClick={() => openDurationPanel(false)}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
      </div>
    );
  };

  const totalDurationFormRender = () => {
    return (
      <div>
        <div className="sidePanel-form">
          <Box mt={1}>{errorPlaceholder()}</Box>
          <Typography variant="h6" gutterBottom>
            {locale.getMsg('totalDuration')}
          </Typography>
          <Box mb={1}>
            <TextField
              fullWidth
              type="number"
              InputProps={{ inputProps: { min: 1, max: 1440 } }}
              onChange={e => setDuration({ ...duration, selectedTotalTime: parseInt(e.target.value, 10) })}
              value={duration != null ? duration.selectedTotalTime : null}
            />
          </Box>
        </div>
      </div>
    );
  };

  const footerRender = () => {
    return (
      <div className="sidePanel-footer">
        <div className="sidePanel-buttons">
          <div className="sidePanel-BackButton">
            <Button variant="contained" color="secondary" onClick={() => openDurationPanel(false)}>
              {locale.getMsg('back')}
            </Button>
          </div>
          <div className="sidePanel-saveButton">
            <Button
              disabled={!canSave()}
              variant="contained"
              color="primary"
              onClick={treatmentInstanceId == null ? save : saveBundledDuration}
            >
              {locale.getMsg('save')}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open={openDurationPanel} onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '350px' }} id="total-duration">
          {headerRender()}
          {totalDurationFormRender()}
          {footerRender()}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
